import React, { useState } from 'react';
import { Box, Menu, MenuItem, Typography, CircularProgress } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { useTranslation } from 'react-i18next';
import task from "../assets/StatusIcons/task.svg";
import leave from "../assets/StatusIcons/leave.svg";
import present from "../assets/StatusIcons/present.svg";
import tobepaid from "../assets/StatusIcons/tobepaid.svg";
import late from "../assets/StatusIcons/late.svg";

const TaskStatusDropdown = ({ currentStatus, onChange, loading,options  }) => {
  const { t } = useTranslation();

  const priorityOptions = options || ["low", "medium", "high", "urgent"];
    const StatusOptions = ["Start", "Completed",];
const isCompleted = currentStatus === "completed";
const statusLabels = {
  start: t("startTask"),
  completed: t("endTask"),
  assigned: t("statuses.assigned"),
  in_progress: t("statuses.in_progress"),
};
  const statusIcons = {
    low: task,
    medium: task,
    high: task,
    urgent: task,
       assigned: leave,
       completed:present,
       start:tobepaid,
         'in_progress': late,

  };

  const statusStyles = {
    low: { backgroundColor: '#BCBFC2', color: '#44546F' },
    medium: { backgroundColor: '#579DFF', color: '#09326C' },
    high: { backgroundColor: '#FEA362', color: '#702E00' },
    urgent: { backgroundColor: '#F87168', color: '#5D1F1A' },
       assigned: { backgroundColor: '#579DFF', color: '#09326C' },
       completed:{ backgroundColor: '#4BCE97', color: '#164B35' },
       started:{ backgroundColor: '#579DFF', color: '#09326C' },
        'in_progress': { backgroundColor: '#FEA362', color: '#702E00' },
  };

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (priority) => {
    if (priority && !loading) onChange(priority);
    setAnchorEl(null);
  };

  return (
    <>
      <Box
  onClick={!isCompleted ? handleClick : undefined}
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 0.5,
          px: 0.6,
          py: 0.4,
          borderRadius: '4px',
          fontWeight: 400,
          fontFamily: 'Poppins, sans-serif',
          fontSize: '13px',
          cursor: "pointer",
          whiteSpace: 'nowrap',
          ...statusStyles[currentStatus]
        }}
      >
        <img
          src={statusIcons[currentStatus]}
          alt={currentStatus}
          style={{ width: 20, height: 20 }}
        />

        <Typography
          sx={{
            fontSize: '13px',
            fontFamily: 'Poppins, sans-serif',
            color: statusStyles[currentStatus]?.color || '#333'
          }}
        >
          {/* {t(`statuses.${currentStatus}`)} */}
          {statusLabels[currentStatus] || t(`statuses.${currentStatus}`)}

        </Typography>

        {/* ✅ Show loader while API calling */}
       {!isCompleted && (
  loading ? (
    <CircularProgress size={14} sx={{ color: statusStyles[currentStatus]?.color }} />
  ) : (
    <ArrowDropDownIcon
      sx={{ fontSize: 18, color: statusStyles[currentStatus]?.color }}
    />
  )
)}

      </Box>

      <Menu anchorEl={anchorEl} open={open} onClose={() => handleClose(null)}>
        {priorityOptions.map((priority) => (
          <MenuItem key={priority} onClick={() => handleClose(priority)}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <img
                src={statusIcons[priority]}
                alt={priority}
                style={{ width: 16, height: 16 }}
              />
              <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontSize: '13px' }}>
{statusLabels[priority] || t(`statuses.${priority}`)}              </Typography>
            </Box>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default TaskStatusDropdown;